<template>
	<div class="content-box p-4">
		<div class="row">
			<div class="col-2 d-flex justify-content-center align-items-center">
				<slot name="image"></slot>
			</div>
			<div class="col-10">
				<h3 class="sub-title text-capitalize">
					<slot name="title"></slot>
				</h3>
				<p class="description">
					<slot name="description"></slot>
				</p>
				<div>
					<slot name="copyLinkBody"></slot>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "FinalizeSectionsUI",
};
</script>

<style lang="scss" scoped>
.content-box {
	@extend %background-grey-1-border-white-1;
	border-radius: $radius-44;
	color: $color-white;

	.sub-title {
		@extend %font-60-79-bold;
	}

	.description {
		@extend %font-26_28-regular;
	}
}
</style>
